export const severity = {
  null: "Not defined",
};
